import { dataProps } from './properties'

export const setBankMasterList = (state, payload) => {
    state.list = payload
}    

export const setBankMasterData = (state, payload) => {
    state.props = payload
} 

export const resetBankMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/bankMaster/mutations.js